import * as Yup from 'yup';
import { VALIDATORS } from 'constants/index';
import { uniqueEmailValidator } from 'utils/form';

export const loginDetailsValidationSchema = Yup.object().shape({
  email: Yup.string()
    .matches(VALIDATORS.EMAIL, { message: 'Please enter a valid email.' })
    .required('Email is required'),
  password: Yup.string()
    .min(8, 'Password must contain at least 8 characters')
    .required('Password must contain at least 8 characters'),
});

export const resetPasswordValidationSchema = Yup.object().shape({
  code: Yup.string().required(),
});

export const resetEmailValidationSchema = Yup.object().shape({
  email: uniqueEmailValidator,
});
